
import AdminDashboardGuard from '@organisms/AdminDashboardGuard';
import MemberVerificationGuard from '@organisms/MemberVerificationGuard';
import PageNotFound from '@pages/PageNotFound';
import CostcoCallback from '@pages/CostcoCallback';
import CostcoSubscription from '@pages/CostcoSubscription';
import MilitaryVerification from '@pages/MilitaryVerification';
import MilitaryCallback from '@pages/MilitaryCallback';
import BookOrder from '@pages/BookOrder';
import MilitaryReauthorize from '@pages/MilitaryReauthorize';

export const ROUTES = [
  // {
  //   key: 'book-order',
  //   path: '/book-order',
  //   element: BookOrder,
  // },
  {
    key: 'military-reauthorize',
    path: '/military/reauthorize',
    element: MilitaryReauthorize,
  },
  {
    key: 'member-verification',
    path: '/member-verification',
    element: MemberVerificationGuard,
  },
  {
    key: 'costco-subscription',
    path: '/costco-subscription',
    element: CostcoSubscription,
  },
  {
    key: 'costcoMembershipDashboard',
    path: '/admin-dashboard',
    element: AdminDashboardGuard,
  },
  {
    key: 'costcoCallback',
    path: '/mvt/callback',
    element: CostcoCallback,
  },
  {
    key: 'military-callback',
    path: '/military/verify/callback',
    element: MilitaryCallback,
  },
  {
    key: 'military-verification',
    path: '/military/verify/:verificationId',
    element: MilitaryVerification,
  },
  {
    key: 'pageNotFound',
    path: '/not-authorized',
    element: PageNotFound,
  },
];
